import './App.css';
import Container from 'react-bootstrap/Container';
import { TokenController } from "./TokenController";

function App()
{
  return (
    <Container>
      <TokenController/>
    </Container>
  );
}

export default App;
